/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateFaqDtoGen,
  MrfiktivExceptionViewmodelGen,
  MrfiktivFaqControllerFindAllParamsGen,
  MrfiktivFaqViewModelGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateFaqDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FrequentlyAskedQuestionsService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Frequently Asked Questions Service
   * @name FaqControllerCreate
   * @summary Create a FAQ for a partner
   * @request POST:/partner/{partnerId}/faq
   * @secure
   * @response `200` `MrfiktivFaqViewModelGen` The created FAQ
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  faqControllerCreate = (partnerId: string, data: MrfiktivCreateFaqDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivFaqViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/faq`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Frequently Asked Questions Service
   * @name FaqControllerFindAll
   * @summary Get all FAQs from a partner
   * @request GET:/partner/{partnerId}/faq
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivFaqViewModelGen)[] })`
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  faqControllerFindAll = ({ partnerId, ...query }: MrfiktivFaqControllerFindAllParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivFaqViewModelGen[] }, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/faq`,
      method: "GET",
      query: query,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Frequently Asked Questions Service
   * @name FaqControllerFindOne
   * @summary Get a FAQ from a partner
   * @request GET:/partner/{partnerId}/faq/{id}
   * @response `200` `MrfiktivFaqViewModelGen` The FAQ
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  faqControllerFindOne = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFaqViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/faq/${id}`,
      method: "GET",
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Frequently Asked Questions Service
   * @name FaqControllerUpdate
   * @summary Update a FAQ entry from a partner
   * @request PATCH:/partner/{partnerId}/faq/{id}
   * @secure
   * @response `200` `MrfiktivFaqViewModelGen` The FAQ
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  faqControllerUpdate = (partnerId: string, id: string, data: MrfiktivUpdateFaqDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivFaqViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/faq/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Frequently Asked Questions Service
   * @name FaqControllerRemove
   * @summary Delete a FAQ from a partner
   * @request DELETE:/partner/{partnerId}/faq/{id}
   * @secure
   * @response `200` `MrfiktivFaqViewModelGen` The deleted FAQ
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  faqControllerRemove = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFaqViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/faq/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
}
